import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { getAssetUrl } from "helpers/assetHelpers";

import { styles } from "./world-card.css";

import { t } from "../../translations/i18n";

export type WorldStatus = "live" | "draft";

@customElement("world-card")
export class WorldCard extends LitElement {
  static override styles = styles;

  @property({ type: String })
  override id = "";

  @property({ type: String })
  name = "";

  @property({ type: String })
  mediaUrl?: string;

  @property({ type: Number })
  mediaPositionX?: number;

  @property({ type: Number })
  mediaPositionY?: number;

  @property({ type: Number })
  postCount = 0;

  @property({ type: String })
  status: WorldStatus = "draft";

  @property({ type: Boolean })
  showDelete = false;

  private handleCardClick = () => {
    this.dispatchEvent(
      new CustomEvent("world-edit", {
        bubbles: true,
        composed: true,
        detail: {
          worldId: this.id,
          worldData: {
            id: this.id,
            name: this.name,
            mediaUrl: this.mediaUrl,
            thumbnailFileId: undefined, // Not available in card data
          },
        },
      }),
    );
  };

  private handleDeleteClick = () => {
    this.dispatchEvent(
      new CustomEvent("world-delete", {
        bubbles: true,
        composed: true,
        detail: {
          worldId: this.id,
          worldName: this.name,
        },
      }),
    );
  };

  private handleDropdownItemClick(event: CustomEvent) {
    const { action } = event.detail;

    if (action === "edit") {
      this.handleCardClick();
    }

    if (action === "delete") {
      this.handleDeleteClick();
    }
  }

  protected override render() {
    const resolvedImageUrl = getAssetUrl(this.mediaUrl);
    const positionX = this.mediaPositionX ?? 50;
    const positionY = this.mediaPositionY ?? 50;
    const backgroundStyle = resolvedImageUrl
      ? `background-image: url(${resolvedImageUrl}); background-position: ${positionX}% ${positionY}%`
      : "";

    return html`
      <div class="world-card clickable" data-status="${this.status}" style="${backgroundStyle}">
        <div class="gradient-overlay"></div>
        ${this.showDelete
          ? html`
              <dropdown-menu class="menu" placement="bottom-end" @dropdown-item-click=${this.handleDropdownItemClick}>
                <ph-dots-three slot="trigger" size="20" class="menu-dots"></ph-dots-three>
                <dropdown-menu-item action="edit" label=${t("links.menu.edit")}>
                  <ph-pencil-line slot="icon" size="16"></ph-pencil-line>
                </dropdown-menu-item>
                <dropdown-menu-item action="delete" label=${t("links.menu.delete")}>
                  <ph-trash-simple slot="icon" size="16"></ph-trash-simple>
                </dropdown-menu-item>
              </dropdown-menu>
            `
          : ""}
        <div class="content">
          <h3 class="world-title">${this.name}</h3>
          <p class="post-count">${this.postCount} Items</p>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "world-card": WorldCard;
  }
}
